define([
    "dojo/_base/declare",
    "dojo/dom-style",
    "dijit/layout/_LayoutWidget",
    "MW/layout/ChildLender",
    "MW/layout/HidingContainer",
    "MW/layout/LayoutChildProperty",
    "MW/layout/TabContainer"
], function (declare, domStyle, _LayoutWidget, ChildLender, HidingContainer, LayoutChildProperty, TabContainer) {

    /**
     * This is a mixin that implements the ChildLender interface for TabContainers.  It enables a TabContainer
     * to temporarily lend out panels.
     */
    var TabContainerLender = declare([ChildLender], {

        borrowChild: function (properties) {
            var widget = this._getWidgetFromProperties(properties);
            if (widget) {
                widget._lendingTabContainer = this;
                this._superRemoveChild(widget);
                // Make the widget visible if necessary
                if (widget !== this.get(TabContainer.SHOWING_CHILD)) {
                    domStyle.set(widget.domNode, {visibility: "visible"});
                }
            }
            return widget;
        },

        returnChild: function (properties) {
            var widget = this._getWidgetFromProperties(properties);
            if (widget) {
                this._superAddChild(widget);
                // Hide the widget if necessary
                if (widget === this.get(TabContainer.SHOWING_CHILD)) {
                    properties.set(LayoutChildProperty.IS_SHOWING, HidingContainer.isShowingGlobally(this));
                } else {
                    domStyle.set(widget.domNode, {visibility: "hidden"});
                }
                delete widget._lendingTabContainer;
            }
        },

        _getWidgetFromProperties: function (properties) {
            var i;
            for (i = 0; i < this._tabInfo.length; i++) {
                if (this._tabInfo[i].properties === properties) {
                    return this._tabInfo[i].widget;
                }
            }
            return null;
        },

        _superAddChild: function (child) {
            _LayoutWidget.prototype.addChild.apply(this, [child]);
        },

        _superRemoveChild: function (child) {
            _LayoutWidget.prototype.removeChild.apply(this, [child]);
        }
    });

    TabContainerLender.getOwningTabContainer = function (widget) {
        var parent = widget.getParent();
        return (parent && parent.isInstanceOf(TabContainer)) ? parent : widget._lendingTabContainer;
    };

    return TabContainerLender;
});